'use client';
import * as React from 'react';

import createSvgIcon from './createSvgIcon';

export default createSvgIcon(
  <path d="M20.5,18 C21.3284271,18 22,18.6715729 22,19.5 C22,20.3284271 21.3284271,21 20.5,21 L3.5,21 C2.67157288,21 2,20.3284271 2,19.5 C2,18.6715729 2.67157288,18 3.5,18 L20.5,18 Z M20.5,11 C21.3284271,11 22,11.6715729 22,12.5 C22,13.3284271 21.3284271,14 20.5,14 L3.5,14 C2.67157288,14 2,13.3284271 2,12.5 C2,11.6715729 2.67157288,11 3.5,11 L20.5,11 Z M20.5,4 C21.3284271,4 22,4.67157288 22,5.5 C22,6.32842712 21.3284271,7 20.5,7 L3.5,7 C2.67157288,7 2,6.32842712 2,5.5 C2,4.67157288 2.67157288,4 3.5,4 L20.5,4 Z" />,
  'Menu'
);
